import { ExternalLayout } from './ExternalLayout';
import { FullScreenLayout } from './FullScreenLayout';
import { Layout } from './Layout';
import { VerificationLayout } from './VerificationLayout';

export { ExternalLayout, FullScreenLayout, VerificationLayout };

export default Layout;
